const  result = [
    {
      category:"Normal",
      emoji:"😀",
      explanation:"Your score falls within the normal range, indicating that you are likely managing your mental health well",
      Recommendation:"Continue practicing self-care routines, maintain social connections, and seek support if you encounter challenges"
    },
    {
      category:"Normal Symptoms",
      emoji:"🫡",
      explanation:"While your score is still in the normal range, there may be some mild symptoms present",
      Recommendation:"Pay attention to your mental health and consider implementing stress-management techniques such as mindfulness or seeking support from a therapist if symptoms persist or worsen"
    },
    {
      category:"Below Moderate",
      emoji:"😐",
      explanation:"our score suggests the presence of moderate symptoms that may be impacting your daily life",
      Recommendation:"Take proactive steps to address your mental health, such as reaching out to a therapist or counselor for support, practicing self-care regularly, and seeking out coping strategies"
    },
    {
      category:"Moderate",
      emoji:"😑",
      explanation:"You are experiencing moderate symptoms that may be significantly affecting your well-being and functioning",
      Recommendation:"It's important to prioritize your mental health by seeking professional help from a therapist or psychiatrist. Engage in therapy sessions regularly and consider medication management if recommended by a healthcare provider"
    },
    {
      category:"Need to Talk with a Psychiatrist",
      emoji:"😶",
      explanation:"Your score indicates severe symptoms that require immediate attention from a mental health professional",
      Recommendation:"Schedule an appointment with a psychiatrist for a comprehensive evaluation and treatment plan. In addition to therapy and possibly medication, consider involving a support system of friends, family, or support groups"
    }
]

export default result;